import React from "react";
import BusinessListingPage from "../../components/BusinessListingPage";

const Restaurant = () => {
  const promoImages = [
    {
      id: 1,
      tag: "FREE DELIVERY",
      tagColor: "green",
      title: "Order now, we fit deliver FREE",
      subtitle: "Fast delivery. Zero charges.",
      buttonText: "Order Now",
      bgColor: "bg-green-50",
      textColor: "text-green-800",
      buttonColor: "bg-green-500 hover:bg-green-600",
    },
    {
      id: 2,
      tag: "BULK ORDERS",
      tagColor: "purple",
      title: "Big event bulk order? We dey on time!",
      subtitle: "Reliable for events, catering, and large requests.",
      buttonText: "Order Now",
      bgColor: "bg-purple-50",
      textColor: "text-purple-800",
      buttonColor: "bg-purple-600 hover:bg-purple-700",
    },
    {
      id: 3,
      tag: "BEST VALUE",
      tagColor: "orange",
      title: "Chop plenty, pay small & enjoy better life",
      subtitle: "Affordable meals for every taste and budget.",
      buttonText: "See Menu Deals",
      bgColor: "bg-orange-50",
      textColor: "text-orange-800",
      buttonColor: "bg-orange-600 hover:bg-orange-700",
    },
  ];

  return (
    <BusinessListingPage
      title=""
      bannerText="RESTAURANTS NEAR YOU"
      businessType="restaurant"
      promoImages={promoImages}
    />
  );
};

export default Restaurant;
